<template>
  <el-dialog
    title="Prestatie Timeline"
    :visible.sync="dialogVisible"
    width="30%">

    <el-timeline :reverse="false">
      <el-timeline-item
        v-for="(h, index) in history"
        :key="index"
        :timestamp="moment(h.createdAt).format('DD-MM-YYYY HH:mm')">
        <div v-if="isNew(h.status)">Prestatie aangemaakt door <i>{{h.by}}</i></div>
        <div v-else>Status gewijzigd naar <strong>{{ getName(h.status) }}</strong> door <i>{{h.by}}</i></div>
      </el-timeline-item>
    </el-timeline>

    <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="dialogVisible = false">Sluiten</el-button>
  </span>
  </el-dialog>
</template>

<script>
    export default {
        name: "PerformanceHistoryDialog",
        data() {
            return {
                dialogVisible: false,
                history: []
            }
        },
        methods: {
            showHistory(session) {
              this.dialogVisible = true;

              this.$http.get(`admin/sessions/${session.id}/history`).then((response) => {
                  this.history = response.data
                  console.log(this.history)
              }).catch(function (error) {
                  console.log(error)
              })
            },
            isNew(status) {
                return status === "SESSION_IN_PROGRESS";
            },
            getName(status) {
                switch(status) {
                    case "SESSION_CANCELLED":
                        return 'Verworpen'
                    case "SESSION_IN_PROGRESS":
                        return 'Nieuw'
                    case "SESSION_CONFIRMED":
                        return 'Bevestigd'
                    case "SESSION_PAID":
                        return 'Betaald'
                    default:
                        return 'Onbekend'
                }
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dashboard/prestations/dialogs/PerformanceHistoryDialog.vue